import {Component, Input,} from '@angular/core';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent {

  @Input()
  public noSpace: boolean;
  @Input()
  public hollow: boolean;
}
